
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  loading: boolean;
  error: string | null;
  authReady: boolean; // New flag to track auth readiness
}

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  loading: false,
  error: null,
  authReady: false, // Default to false until auth process completes
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ token: string; refreshToken: string; }>
    ) => {
        
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.error = null;
    },
    logout: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setAuthReady: (state, action: PayloadAction<boolean>) => {
      state.authReady = action.payload;
    }
  },
});

export const { setCredentials, logout, setLoading, setError, setAuthReady } = authSlice.actions;
export default authSlice.reducer;
